import { createContext, useContext } from 'react'

import type { ProviderPropsExternal } from './UnsavedChangesProvider'

const UnsavedChangesContext = createContext<ProviderPropsExternal | null>(null)

const useOptionalUnsavedChangesContext = () => {
  const context = useContext(UnsavedChangesContext)

  return (context ?? {}) as unknown as Partial<ProviderPropsExternal>
}

const useUnsavedChangesContext = () => {
  const context = useContext(UnsavedChangesContext)

  if (!context) {
    throw new Error(
      'You must wrap your app in a UnsavedChangesProvider to use the UnsavedChangesContext',
    )
  }

  return context
}
const Provider = UnsavedChangesContext.Provider

export { Provider, useOptionalUnsavedChangesContext, useUnsavedChangesContext }
